// extracted by mini-css-extract-plugin
module.exports = {"tabTitle":"style__tabTitle__lF4X+"};